import { render, staticRenderFns } from "./star.vue?vue&type=template&id=4a0ce206&scoped=true"
import script from "./star.vue?vue&type=script&lang=js"
export * from "./star.vue?vue&type=script&lang=js"
import style0 from "./star.vue?vue&type=style&index=0&id=4a0ce206&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ce206",
  null
  
)

export default component.exports